// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","cls2":"_1dnRv","cls6":"_2EvIr","cls5":"_1PbhJ","cls3":"_1yNYF","cls11":"_14cl3","cls10":"_2TAhS"};